export default __webpack_public_path__ + "static/media/guide1.c33cf496.svg";